import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import Antd, { Modal } from 'ant-design-vue';
import vuescroll from 'vuescroll';
import 'ant-design-vue/dist/antd.min.css';
import mixin from './mixin';
import { customIcon } from './common/utils';

Vue.config.productionTip = false;
Vue.use(Antd);
Vue.use(customIcon);
Vue.mixin(mixin);

Vue.use(vuescroll, {
    ops: {
        bar: {
            background: '#999',
            size: '8px',
            keepShow: true
        }
    },
    name: 'vuescroll'
});

Vue.prototype.$confirm = function (title, content, okText, cancelText) {
    return new Promise((resolve, reject) => {
        Modal.confirm({
            title,
            content,
            okText: okText || '确定',
            cancelText: cancelText || '取消',
            onOk: () => {
                resolve();
            },
            onCancel: () => {
                reject();
            }
        });
    });
};

new Vue({
    store,
    router,

    render: h => h(App)
}).$mount('#app');
